import { render, staticRenderFns } from "./ErrTab.vue?vue&type=template&id=9707052e&scoped=true"
import script from "./ErrTab.vue?vue&type=script&lang=js"
export * from "./ErrTab.vue?vue&type=script&lang=js"
import style0 from "./ErrTab.vue?vue&type=style&index=0&id=9707052e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9707052e",
  null
  
)

export default component.exports